<aims-common-button (click)="export()" >
    <mat-icon>get_app</mat-icon> 
    Export to Excel
</aims-common-button>
